import * as Actions from '../../actions';

const initialState = { data: null };

const userReportScheduleReducer = function (state = initialState, action) {
    switch (action.type) {
        case Actions.GET_USER_REPORT_SCHEDULE:
            return { ...state, data: { ...action.payload } };
        default:
            return state;
    }
};

export default userReportScheduleReducer;
